import AudiencesModel from '../model/AudiencesModel';

export type SearchAttributes = {
  [key: string]: string[];
};

export type LeadsSearchIndividual = {
  age: number;
  city: string;
  email: string;
  firstname: string;
  occupation: string;
  permIndividualId: string;
  sex: string;
  state: string;
  converted: boolean;
};

export type LeadsSearchResponse = {
  total?: {
    value: number;
    relation: 'gte' | 'eq';
  };
  hits?: LeadsSearchIndividual[];
};

export type LeadsSearchQuery = {
  fbPageId?: number;
  query: [string, string][];
  offset?: number;
  exclude?: [string, string][];
  limit?: number;
};

export type ConvertationRequest = {
  leadIds?: string[];
  excludedLeadIds?: string[];
  searchBody?: LeadsSearchQuery;
};

export type ConvertationRequestStatus =
  | 'queued'
  | 'processed'
  | 'processing'
  | 'failed';

export type ConvertLeadsResponse = {
  id: number;
  facebookPageId: number;
  audience: AudiencesModel;
  excludedLeadIds: string[];
  leadIds: string[];
  searchBody: LeadsSearchQuery;
  freezedCredits: null | number;
  status: ConvertationRequestStatus;
  userId: number;
};

export type LeadsState = {
  busy: boolean;
  attributes: SearchAttributes;
  contacts: LeadsSearchResponse;
  freezedCretitsSum: number;
};

export type LeadsSearchKeyType =
  | 'busOwner'
  | 'credrate'
  | 'incomesthh'
  | 'education'
  | 'numchild'
  | 'prflLgbtSupport'
  | 'religion'
  | 'sex'
  | 'etnicCod'
  | 'mrtlstatus'
  | 'networth'
  | 'partyCode'
  | 'occupation'
  | 'autoEco'
  | 'fuel'
  | 'homemktval'
  | 'homeownrnt'
  | 'occdetailDesc'
  | 'autobody'
  | 'colAntiq'
  | 'colArts'
  | 'beauty'
  | 'bksmagBks'
  | 'catowner'
  | 'donation'
  | 'chGen'
  | 'colCoin'
  | 'dogowner'
  | 'colSport'
  | 'donEnvir'
  | 'foodWine'
  | 'foodsnat'
  | 'gamBoard'
  | 'gamCasino'
  | 'gamComp'
  | 'gamVid'
  | 'gaming'
  | 'motorcycle'
  | 'scispace'
  | 'scubadiver'
  | 'smoking'
  | 'dieting'
  | 'prflGunControl'
  | 'prflMarijuanaReform'
  | 'prflMilSupport'
  | 'singparent'
  | 'specBase'
  | 'boating'
  | 'specHock'
  | 'golf'
  | 'nascar'
  | 'snowski'
  | 'specSocc'
  | 'tennis'
  | 'email'
  | 'phoneNum'
  | 'municipality'
  | 'city'
  | 'state'
  | 'zip'
  | 'firstname'
  | 'lastname'
  | 'invReal'
  | 'invStocks'
  | 'age'
  | 'address'
  | 'county';

export enum LeadsSearchFriendlyName {
  BUS_OWNER = 'Business Owner',
  CREDRATE = 'Credit Rating',
  INCOMESTHH = 'Estimated Household Income',
  INV_REAL = 'Real Estate Investor',
  INV_STOCKS = 'Stocks and Bonds Investor',
  OCCUPATION = 'Occupation',
  FUEL = 'Home Fuel Type',
  HOMEMKTVAL = 'Home Value',
  PROPERTY_TYPE = 'Property type',
  HOMEOWNRNT = 'Own or rent their home',
  MUNICIPALITY = 'Municipality',
  ADDRESS = 'Adress',
  CITY = 'City',
  STATE = 'State',
  COUNTY = 'County',
  ZIP = 'Zip Code',
  BEAUTY = 'Beauty and Cosmetics',
  BKSMAG_BKS = 'Books',
  CATOWNER = 'Cat Owner',
  CH_GEN = 'Childrens Products',
  COL_ANTIQ = 'Antiques',
  COL_ARTS = 'Art',
  COL_COIN = 'Coins',
  DONATION = 'Charitable Donor',
  SEX = 'Gender',
  DIETING = 'Dieting/Weight Loss',
  EDUCATION = 'Education Level',
  NUMCHILD = 'Number of Children',
  PRFL_GUN_CONTROL = 'Gun Control Supporters',
  PRFL_LGBT_SUPPORT = 'LGBTQ+ Donor/Supporter',
  PRFL_MARIJUANA_REFORM = 'Marijuana Supporter',
  PRFL_MIL_SUPPORT = 'Military Supporters',
  RELIGION = 'Religion',
  SINGPARENT = 'Single Parent',
  AGE = 'Age',
  DOGOWNER = 'Dog Owner',
  COL_SPORT = 'Sports Memorabilia',
  MRTLSTATUS = 'Marital Status',
  NETWORTH = 'Net Worth',
  PARTY_CODE = 'Political Party',
  BOATING = 'Boating/Sailing',
  DON_ENVIR = 'Environmental Issues Donor',
  EQUESTRIAN = 'Equestrian',
  EXERCISE = 'General Exercise',
  FISHING = 'Fishing',
  FOOD_WINE = 'Food and Wine',
  FOODSNAT = 'Natural Foods',
  GAM_BOARD = 'Board Games',
  GAM_CASINO = 'Sports Betting',
  GAM_COMP = 'Computer Games',
  GAM_VID = 'Video Games',
  GAMING = 'Casino Gaming',
  GARDNER = 'Gardening',
  GOLF = 'Golfer',
  MOTORCYCLE = 'Motorcycling',
  NASCAR = 'NASCAR',
  READER = 'Reader',
  SCISPACE = 'Science/Space',
  SCUBADIVER = 'Scuba Diving',
  SMOKING = 'Smoker',
  SNOWSKI = 'Ski/Snowboard',
  SPEC_BASE = 'Baseball',
  SPEC_HOCK = 'Ice Hockey',
  SPEC_SOCC = 'Soccer',
  TENNIS = 'Tennis',
  TRAVELER = 'Traveler',
  FIRSTNAME = 'First Name',
  LASTNAME = 'Last Name',
  EMAIL = 'Email',
  PHONE_NUM = 'Phone Number',
  AUTO_BODY = 'Auto Body Type',
  AUTO_ECO = 'Auto is Eco Friendly',
}
